import type { LiveClass } from "@/hooks/useStudentDashboard";

interface LiveClassCardProps {
  liveClass: LiveClass | null;
  loading: boolean;
}

function formatDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleString("tr-TR", {
    day: "numeric",
    month: "long",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export default function LiveClassCard({ liveClass, loading }: LiveClassCardProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="flex items-center gap-2">
        <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
          <i className="ri-vidicon-line text-base" aria-hidden="true"></i>
        </span>
        <h2 className="font-heading font-semibold text-sm text-foreground-950">Sıradaki Canlı Ders</h2>
      </div>

      {loading ? (
        <div className="mt-4 space-y-2">
          <div className="h-4 w-3/4 rounded bg-background-100 animate-pulse" />
          <div className="h-3 w-1/2 rounded bg-background-100 animate-pulse" />
        </div>
      ) : liveClass ? (
        <div className="mt-4">
          <p className="text-sm font-semibold text-foreground-900">{liveClass.title}</p>
          <p className="mt-1 text-xs text-foreground-600">
            {liveClass.subject}
            {liveClass.teacher_name ? ` · ${liveClass.teacher_name}` : ""}
          </p>
          <p className="mt-2 inline-flex items-center gap-1.5 text-xs font-medium text-accent-800 bg-accent-100 px-2 py-1 rounded-full">
            <i className="ri-time-line text-sm" aria-hidden="true"></i>
            {formatDate(liveClass.starts_at)}
          </p>
        </div>
      ) : (
        <p className="mt-4 text-sm text-foreground-600">
          Planlanmış canlı ders yok. Canlı dersler atandığında burada görünecek.
        </p>
      )}
    </div>
  );
}